import { useCallback, useState } from 'react';

import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { useUserClubs } from '@queries';
import { activityAtom, isCurrentActivityAtom } from '@store';
import { PropertyControl } from '@ui';

import { LINKS } from '../../utils/routes';

import { EditClubsModal } from './EditClubsModal';

const ALL = 'all';
const BAG = 'bag';
const CLUB = 'Club';

export const ClubPropertyControl = () => {
    const isCurrentActivity = useAtomValue(isCurrentActivityAtom);
    const navigate = useNavigate();
    const activity = useAtomValue(activityAtom);
    const { data: userClubs } = useUserClubs();
    const [isOpen, setIsOpen] = useState(false);
    const currentClub = activity?.club ? { label: activity.club.shortName } : { label: CLUB };

    const handleClick = useCallback(() => {
        if (!isCurrentActivity) {
            navigate(`${LINKS.getClubs()}?display=${!userClubs?.length ? ALL : BAG}`);
            return;
        }
        setIsOpen(true);
    }, [isCurrentActivity, navigate, userClubs?.length]);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    return (
        <>
            <PropertyControl values={[currentClub]} onClick={handleClick} />
            {isOpen && isCurrentActivity && activity && (
                <EditClubsModal
                    key={activity.id}
                    activityId={activity.id}
                    currentClubId={activity.club?.id}
                    isCurrentActivity={isCurrentActivity}
                    onClose={handleClose}
                />
            )}
        </>
    );
};
